module.exports = __webpack_public_path__ + "img/cursor_arrowDown.310fb566.svg";